if (!customElements.get('main-product-related-slider')) {
  class MainProductRelatedSlider extends HTMLElement {
    connectedCallback() {
      if (this.slider || typeof Swiper === 'undefined') return;

      const prevButton = this.dataset.prevBtn
        ? document.querySelector(this.dataset.prevBtn)
        : null;
      const nextButton = this.dataset.nextBtn
        ? document.querySelector(this.dataset.nextBtn)
        : null;

      this.slider = new Swiper(this, {
        a11y: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        threshold: 3,
        resistanceRatio: 0.72,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        }
      });
    }
  }

  customElements.define('main-product-related-slider', MainProductRelatedSlider);
}

document.addEventListener('click', event => {
  const tab = event.target.closest('[data-main-product-related-tab]');
  if (!tab) return;

  const relatedBlock = tab.closest('.main-product-related');
  if (!relatedBlock) return;

  const targetPanel = tab.dataset.mainProductRelatedTab;

  relatedBlock
    .querySelectorAll('[data-main-product-related-tab]')
    .forEach(item => {
      item.setAttribute(
        'aria-selected',
        item.dataset.mainProductRelatedTab === targetPanel ? 'true' : 'false'
      );
    });

  relatedBlock
    .querySelectorAll('[data-main-product-related-panel]')
    .forEach(panel => {
      panel.classList.toggle(
        'is-active',
        panel.dataset.mainProductRelatedPanel === targetPanel
      );
    });

  relatedBlock
    .querySelectorAll('.main-product-related__panel.is-active main-product-related-slider')
    .forEach(slider => {
      if (slider.slider) slider.slider.update();
    });
});
